// initializing swell functions
(function() {
    $(document).ready(function() {
      SwellConfig.Link.initializeLinks(".swell-link-login, .swell-link-register");
      SwellConfig.LocalStorage.initializeLocalStorage();
      $(document).on("swell:setup", function() {
        SwellConfig.Referral.initializeReferral(".swell-referral");
        SwellConfig.Referral.populateReferrals(".swell-referral-table .table-data");
        Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
        SwellConfig.Campaign.authenticate();
        SwellConfig.Campaign.appendReferralImage(".swell-campaign-list");
        Swell.Redemption.initializeProductRedemptions(".swell-redemption-option-list", SwellConfig.Redemption.opts);
        if(window.location.href.indexOf("account") > -1) {
          SwellConfig.Redemption.initializeSliderAccount(".swell-redemption-option-list-account");
        } else {
          SwellConfig.Redemption.initializeSlider(".swell-redemption-option-list");
        }
        SwellConfig.Redemption.initializeProducts();
        $(".big-spinner").hide();
        
        var campaign_image = '//www.stevemadden.com/cdn/shop/t/1716/assets/SMPASS.jpg?v=585849'
        $(".swell-campaign-list > .swell-campaign:nth-child(4)").after('<li class="swell-campaign smpass-logo"> <img src="' + campaign_image + '"> </li>');
        $(".swell-campaign-content[data-campaign-id=440272]").parent().remove();
      });
  
      $(document).on("swell:referral:success", function() {
        swellAPI.refreshCustomerDetails(function() {
          SwellConfig.Referral.populateReferrals(".swell-referral-table .table-data");
        });
      });
  
      $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) { 
        if(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED"){
          $(".refer-customer-error").remove();
          $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Sorry! Looks like this person has already made a purchase. Try referring another friend.</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
      });
  
      $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) { 
        if(textStatus && textStatus === "Please enter a valid email address"){
          $(".refer-customer-error").remove();
          $(".swell-referral-form-body").prepend('<p class="refer-customer-error">Please enter valid email addresses separated with commas</p>');
          $("#swell-referral-refer-emails").addClass("error-border");
        }
      });
  
      $(document).on('click', '.swell-share-referral-copy', function() {
        setTimeout(function() { 
          var referral_copy = $(".swell-referral-copy").detach();
          $(".swell-referral-holder").prepend(referral_copy);
          referral_copy.css("display", "flex");
        }, 10);
      });
    });
  }).call(this);
  
  // defining campaigns template
  (function() {
    window.SwellConfig = window.SwellConfig || {};
  
    SwellConfig.Campaign = {
      opts: {
        templates: {
          campaign: "<li class='swell-campaign'>  <div class='swell-campaign-content' data-display-mode='modal'   data-campaign-id='<%= campaign.id %>'> <div class='holder'> <div class='swell-campaign-icon'>      <span class='swell-campaign-icon-content'><i class='fa <%= campaign.icon %>'><span class='path1'></span><span class='path2'></span><span class='path3'></span><span class='path4'></span><span class='path5'></span><span class='path6'></span></i></span>    </div>    <div class='swell-campaign-value'>      <span class='swell-campaign-value-content'><%= campaign.reward_text %></span>    </div>    <div class='swell-campaign-type'>      <span class='swell-campaign-type-content'><%= campaign.title %></span>    </div>  </div> </div></li>",
          campaignHover: "<div class='hover-block'> <div class='holder'><ul class='swell-link-list'> <li class='swell-link'> <a class='login-btn' href='/account/login'>LOG IN</a> </li> <li class='swell-link or-tag'> <span>or</span> </li> <li class='swell-link'> <a class='sign-up-btn' href='/account/register'>JOIN NOW</a> </li> </ul> </div> </div>"
        }
      },
      authenticate: function() {
        if(spapi.authenticated) {
          $(".swell-campaign").css("cursor", "pointer");
        } else {
          return $(".swell-campaign-content").hover(function() {
            return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
          }, function() {
            return $(this).find(".hover-block").remove();
          });
        }
      },
      appendReferralImage: function(containerSelector) { 
        var url = '//www.stevemadden.com/cdn/shop/t/1716/assets/refer-block-img.png?v=585849'
        $(containerSelector).append("<li class='swell-campaign refer-campaign-list'>  <div class='swell-campaign-content'> <div class='holder'> <div class='deatils-holder'> <h3>Refer Friends and Earn Points</h3> <p><span>Refer new friends and earn $10.</span> <a href='/pages/refer'>Start referring here.</a> </p> </div> </li> </div> </div>  </div> </li>");
      }
    };
  }).call(this);
  
  // defining product redemption template and initializing slick slider for product redemption
  (function() {
    window.SwellConfig = window.SwellConfig || {};
  
    SwellConfig.Redemption = {
      opts: {
        templates: {
        redemptionOptionProduct: "<li class='swell-redemption-option'> <div class='swell-redemption-option-holder'> <div class='image-holder swell-redemption-option-content'> <img src='<%= redemption.background_image_url %>'> </div> <div class='swell-product-redeem-button' data-confirm-title='Yes go for it.' data-confirm-content='You currently have *|point_balance|* points. This costs *|amount|*. ' data-success-title='Success.' data-success-content='This was successfully added to your cart.' data-success-cart-btn='View Cart' data-error-title='So close.' data-error-content='This requires *|amount|* points and you only have *|point_balance|*. Earn more to be able to add this to your cart.' data-variant-id='<%= redemption.applies_to_id %>' data-redemption-option-id='<%= redemption.id %>'> REDEEM NOW </div> <div class='swell-redemption-option-value'> <%= redemption.name %> </div> <div class='swell-redemption-option-cost'> <%= redemption.cost_text %> </div> <div class='swell-redemption-option-description'> <%= redemption.description %> </div> </div> </li>"
        }
      },
      initializeSliderAccount: function(containerSelector) {
        $(containerSelector).slick({
          infinite: true,
          prevArrow:"<span class='swell-icon-angle-left prev-arrow'></span>",
          nextArrow:"<span class='swell-icon-angle-right next-arrow'></span>",
          slidesToShow: 3,
          slidesToScroll: 1,
            dots: false,
            autoplay: false,
            responsive: [
              {
               breakpoint: 1024,
               settings: {
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 1
               }
              },
              {
               breakpoint: 767,
               settings: {
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
               }
              }
            ]
        });
      },
      initializeSlider: function(containerSelector) {
        $(containerSelector).slick({
          infinite: true,
          prevArrow:"<span class='swell-icon-angle-left prev-arrow'></span>",
          nextArrow:"<span class='swell-icon-angle-right next-arrow'></span>",
          slidesToShow: 6,
          slidesToScroll: 1,
            dots: false,
            autoplay: false,
            responsive: [
              {
               breakpoint: 1024,
               settings: {
                arrows: true,
                slidesToShow: 4,
                slidesToScroll: 1
               }
              },
              {
               breakpoint: 767,
               settings: {
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1
               }
              },
              {
               breakpoint: 600,
               settings: {
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1
               }
              }
            ]
        });
      },
     initializeProducts: function() {
        if(spapi.authenticated) {
          $(".swell-redemption-option-list .swell-redemption-option .swell-product-redeem-button").css("cursor", "pointer");
          $(".swell-redemption-option-list .swell-redemption-option .swell-product-redeem-button").addClass("swell-buy-product-btn");
          return spapi.setupBuyProductWithPointsHelper();
        } else {
          $(".swell-product-redeem-button").hide();
        }
      }
    };
  }).call(this);
  
  // initializing link so customer's can be redirected back to rewards page -- if signed in through rewards page
  (function() {
    window.SwellConfig = window.SwellConfig || {};
  
    SwellConfig.Link = {
      initializeLinks: function(containerSelector) {
        return $(document).on("click", containerSelector, function(e) {
          var href;
          e.preventDefault();
          href = $(this).attr("href");
          localStorage.setItem("swell-location", "/pages/smpass");
          return window.location = href;
        });
      }
    };
  }).call(this);
  
  // defining local storage for customer's redirection
  (function() {
    window.SwellConfig = window.SwellConfig || {};
  
    SwellConfig.LocalStorage = {
      initializeLocalStorage: function() {
        var location;
        location = localStorage.getItem("swell-location");
        if (location && window.location.pathname === '/account') {
          localStorage.removeItem("swell-location");
          return window.location = location;
        }
      }
    };
  }).call(this);
  
  // defining referral template
  (function() {
    window.SwellConfig = window.SwellConfig || {};
  
    SwellConfig.Referral = {
      opts: {
        localization: {
          referralSidebarDetailsAction: "",
          referralSidebarDetailsReward: "",
  
          referralRegisterHeading: "<span>Refer a Friend</span>Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %> in points",
          referralRegisterFormDetails: "Please submit your email below to get started.",
          referralRegisterFormEmail: "Your email address",
          referralRegisterFormSubmit: "NEXT",
          referralRegisterDetails: "<%= referralCampaign.details %>",
  
          referralReferHeading: "<span>Refer a Friend</span>Give <%= referralCampaign.reward_text %>, Get <%= referralCampaign.reward_text %> in points",
          referralReferFormEmails: "Your friends' emails (separated by commas)",
          referralReferFormSubmit: "SEND",
          referralReferFormDetails: "Now, enter your friends' emails below.",
          referralReferFormEmailsDetails: "",
          referralReferDetails: "<%= referralCampaign.details %>",
  
          referralReferMediaDetails: "You can also share your link with the buttons below",
  
          referralShareFacebook: "Share",
          referralShareCopy: "Copy Link",
  
          referralFacebookIcon: "swell-icon-facebook2",
          referralLinkIcon: "swell-icon-link",
  
          referralThanksHeading: "Thanks for Referring!",
          referralThanksDetails: "Remind your friends to check their emails.",
  
          referralCopyHeading: "",
          referralCopyButton: "Copy Link",
          referralCopyDetails: "Copy link and share with your friends."
        },
        templates: {
          referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-referral-border"></div> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div>',
          referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-referral-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> <span class="swell-referral-form-field-details"></span> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-messenger" aria-hidden="true"></i>&nbsp;Message</div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul></div> </div>'
        }
      },
      populateReferrals: function(containerSelector) {
        if (spapi.authenticated) {
          referral_receipts = spapi.customer.referral_receipts;
  
          $(".swell-stevemadden .redeem-holder").removeClass("swell-hidden");
          var referrals = {};
  
          $.each(referral_receipts, function( index, item ) {
            status = "Invited";
            if (item.completed_at != null) {
              status =  "<span>Purchased" + " (" + spapi.activeReferralCampaign.reward_text + " earned" + ")</span>";
            }
            referrals += "<tr><td class='swell-td'>" + item.email + "</td><td class='swell-td'>" + status + "</td></tr>";
          });
  
          $(containerSelector).html(referrals);
        }
      },
      initializeReferral: function(containerSelector) {
        var email = $(containerSelector).data("customer-email");
        if (email) {
          spapi.storage.setItem("referrer_email", email);
          spapi.customer.email = email;
        }
        Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      }
    };
  }).call(this);
  